import * as React from "react";

import {EntryCard} from "@client/components/EntryCard";
import {Flush} from "@client/components/Flush";
import {Locator} from "@client/gotterdammerung";
import {server} from "@reactivated";

interface Props<
    T extends
        | server.journal.nutrition.Entry.output
        | server.journal.nutrition.Recipe.output,
> {
    entries: T[];
    createLink?: {
        hack(entry: T): string | Locator | (() => void);
    }["hack"];
    createTag?: {
        hack(entry: T): string | null;
    }["hack"];

    switchHandler?: {
        values:
            | {[entryUUID: UUID]: boolean | null}
            | {
                  hack(entry: T): boolean | null;
              }["hack"];
        onSwitch: {
            hack(entry: T): void;
        }["hack"];
    };
    children?: React.ReactNode;
    hiddenMacros: boolean;
}

export const EntryList = <
    T extends
        | server.journal.nutrition.Entry.output
        | server.journal.nutrition.Recipe.output,
>({
    switchHandler,
    ...props
}: Props<T>) => {
    return (
        <>
            {props.children}
            <Flush>
                {props.entries.map((entry) => {
                    const cardSwitchHandler =
                        switchHandler != null
                            ? {
                                  onSwitch: () => switchHandler.onSwitch(entry),
                                  value:
                                      typeof switchHandler.values === "function"
                                          ? switchHandler.values(entry)
                                          : switchHandler.values[entry.uuid],
                              }
                            : undefined;

                    return (
                        <EntryCard
                            key={entry.uuid}
                            entry={entry}
                            switchHandler={cardSwitchHandler}
                            link={
                                props.createLink ? props.createLink(entry) : undefined
                            }
                            tag={
                                props.createTag
                                    ? (props.createTag(entry) ?? undefined)
                                    : undefined
                            }
                            {...props}
                        />
                    );
                })}
            </Flush>
        </>
    );
};

/*

    <div className="row" key={entry.id}>
        {switchHandler != null &&
        <div className="small-3 columns">
            <Switch value={switchHandler.values[entry.id]} onChange={(value) => switchHandler.onSwitch(entry as Entry)} />
        </div>
        }
        <div className="columns">
            {createLink != null ?
            <Link to={createLink(entry)}>{entry.name}</Link>
            :
            <span>{entry.name}</span>
            }
        </div>
    </div>
    )}
   */
